import * as React from "react";

export function getInspectorTooltip(inspectionUid: string): React.ReactElement {
  if (inspectionUid === 'E69B1426-0389-4E10-95BC-FDE0E187E4C2')
    return (<div>
      Ghost: 0 patients <br />
      Peripheral: 0 - 24th percentile in patient volume (based on population density and specialty) <br />
      Standard: 25 - 74th percentile in patient volume (based on population density and specialty) <br />
      Core: 75 - 100th percentile in patient volume (based on population density and specialty) <br />
      RX Only: No medical claims but pharmacy claims present <br />
      Insufficient Data: Not enough data available to make a designation <br />
    </div>);
  else if (inspectionUid === 'C4A5AB3D-3499-431C-86A8-A9D3A0AD0E68')
    return (<div>
      High: 85% or higher confidence practitioner IS at address <br />
      Medium: 51% - 85% confidence practitioner IS at address <br />
      Low: 51% - 85% confidence practitioner is NOT at address <br />
      Very Low: 85% or higher confidence practitioner is NOT at address <br />
    </div>);
  return null;
}

export function getPCATooltip(pcaVolume: string): string {
  switch (pcaVolume) { 
    case "Ghost":
      return "0 patients";
    case "Peripheral":
      return "0 - 24th percentile in patient volume (based on population density and specialty)";
    case "Standard":
      return "25 - 74th percentile in patient volume (based on population density and specialty)";
    case "Core":
      return "75 - 100th percentile in patient volume (based on population density and specialty)";
    case "RX Only":
      return "No medical claims but pharmacy claims present";
    case "InsufficientDataNew":
    case "InsufficientDataSpecialty":
      return "Not enough data available to make a designation";
  }
  return null;
}

export function getLocationConfidenceTooltip(locationConfidence: string): string {
  switch (locationConfidence.replace(/\s+\(\d+\)/, '')) {
    case "High":
      return "85% or higher confidence practitioner IS at address";
    case "Medium":
      return "51% - 85% confidence practitioner IS at address";
    case "Low":
      return "51% - 85% confidence practitioner is NOT at address";
    case "Very Low":
      return "85% or higher confidence practitioner is NOT at address";
  }
  return null;
}